import React, { useCallback } from 'react';
import { Modal, Form } from 'antd';
import CreateShutdownForm from './Form/CreateShutdownForm';
import {
  modalTypes,
  useModalState,
  useModalDispatch,
  modalActionTypes,
} from '../../../../shared/lib/toggleModalVisble';
import { transformFormValues } from '../../common/lib/formValuesHelpers';
import { useCreateShutdown } from '../api';
import { useAutoResponseEventsSubscription } from '../../common/lib/autoResponseTemplateEventsSubscription';
import ModalFooter from './ModalFooter/ModalFooter';
import { changeModalWithInfoBodyStyle } from '../../common/config';
import { isStorageAvailable } from '../../../../../../helpers/storage';
import DraftInfoWithActions from './DraftInfoWithActions/DraftInfoWithActions';

const OpenCreateShutdownModal = ({ render, ...props }) => {
  const dispatch = useModalDispatch();

  const open = useCallback(
    (data) => {
      dispatch({
        type: modalActionTypes.setModalData,
        payload: {
          type: modalTypes.createShutdown,
          ...(data?.initialValues ? { initialValues: data.initialValues } : {}),
        },
      });
    },
    [dispatch]
  );

  return render({ open, ...props });
};

const localStorageAvailable = isStorageAvailable();

const ModalContainer = ({
  form,
  renderResTemplateAction,
  renderResTemplateOptionActions,
}) => {
  const { type, initialValues } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => {
    form.resetFields();
    dispatch({ type: modalActionTypes.resetModalData });
  };

  const { create, loading } = useCreateShutdown();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const { autoResponder, ...restValues } = formValues;
        const values = transformFormValues(restValues);
        await create(values);
        close();
      }
    });
  };

  const visible = type === modalTypes.createShutdown;
  useAutoResponseEventsSubscription({ form, visible });

  return (
    <Modal
      visible={visible}
      onCancel={close}
      onOk={handleSubmit}
      title="Создание отключения"
      style={{ top: '50px' }}
      destroyOnClose
      confirmLoading={Boolean(loading)}
      bodyStyle={
        localStorageAvailable ? changeModalWithInfoBodyStyle : undefined
      }
      footer={
        localStorageAvailable ? (
          <ModalFooter
            loading={Boolean(loading)}
            form={form}
            onCancel={close}
            onSubmit={handleSubmit}
          />
        ) : undefined
      }
    >
      {localStorageAvailable ? <DraftInfoWithActions form={form} /> : null}
      <CreateShutdownForm
        form={form}
        initialValues={initialValues}
        renderResTemplateAction={renderResTemplateAction}
        renderResTemplateOptionActions={renderResTemplateOptionActions}
      />
    </Modal>
  );
};

const CreateShutdownModal = Form.create({ name: 'create_shutdown' })(
  ModalContainer
);

export { CreateShutdownModal, OpenCreateShutdownModal };
